import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

const sliceAreaAtom = atom(null);
const zoomAreaAtom = atom(null);
const unitAtom = atom('%');
const sizeAtom = atom('s');
const diagnosticsModeAtom = atom(false);
const dodAtom = atom(false);
const logAxisAtom = atom(false);

const layoutAtom = atom('horizontal');
const errorResponseAtom = atom({});
// query metrics
const queryMetricsAtom: any = atom([]);

// atom family to manage all metric data flows
const metricPanelDataAtomFamily = atomFamily(
  ({ tag, defaultValue = null }: any) => {
    return atom(defaultValue);
  },
  (a, b) => {
    return a.tag === b.tag;
  },
);

const primaryFilterVisibilityAtom = atom(true);

const metricPanelShareAtom = atom((get) => {
  return {
    sliceArea: get(sliceAreaAtom),
    zoomArea: get(zoomAreaAtom),
    unit: get(unitAtom),
    size: get(sizeAtom),
    diagnosticsMode: get(diagnosticsModeAtom),
    primaryFilterVisibility: get(primaryFilterVisibilityAtom),
  };
});

export {
  sliceAreaAtom,
  zoomAreaAtom,
  unitAtom,
  sizeAtom,
  metricPanelShareAtom,
  diagnosticsModeAtom,
  dodAtom,
  queryMetricsAtom,
  layoutAtom,
  metricPanelDataAtomFamily,
  logAxisAtom,
  errorResponseAtom,
  primaryFilterVisibilityAtom,
};
